import { memo } from "react";
import { useProductBanner } from "./use-product-banner";
import { Banner } from "~/components/blocks/product/common/blocks/product-banner/banner";
import { CATEGORY_IDS } from "~/const/categories";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { G_ServicePlan } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";

type ProductBannerProps = { videoData: G_GetVideoQuery["video"] };

export const ProductBanner = memo(({ videoData }: ProductBannerProps) => {
  const { servicePlan, isFirstSubscribe, isLoggedIn } = useAuth();

  const isLimitedPremium = videoData.campaign?.isLimitedPremium ?? false;
  const isPremiumMemberBefore = isLoggedIn && !isFirstSubscribe;

  const { freeProduct, svodProduct, ppvExpiration } = useProductBanner({ videoData });
  const { categories } = videoData;
  const isDmmTvOriginal = categories.some(({ id }) => id === CATEGORY_IDS.DMM_TV_ORIGINAL);

  // プレミアム会員の場合、プレミアム訴求導線を表示しない
  if (servicePlan === G_ServicePlan.Premium) return null;

  // 購入していた場合、プレミアム訴求導線を表示しない
  if (ppvExpiration !== undefined && ppvExpiration !== null) return null;

  // スポット配信、かつ、無料の場合、プレミアム訴求導線を表示しない
  if (freeProduct !== undefined && freeProduct !== null) return null;

  // SVOD取扱商品でない、かつ、プレミアム会員限定割引がない場合
  if ((svodProduct === undefined || svodProduct === null) && !isLimitedPremium) {
    if (!isDmmTvOriginal) return null;
  }

  return <Banner isLimitedPremium={isLimitedPremium} isPremiumMemberBefore={isPremiumMemberBefore} />;
});

ProductBanner.displayName = "ProductBanner";
